import { render, staticRenderFns } from "./CombinedResultSubjectReportWidget.vue?vue&type=template&id=0d560cee"
import script from "./CombinedResultSubjectReportWidget.vue?vue&type=script&lang=js"
export * from "./CombinedResultSubjectReportWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d560cee')) {
      api.createRecord('0d560cee', component.options)
    } else {
      api.reload('0d560cee', component.options)
    }
    module.hot.accept("./CombinedResultSubjectReportWidget.vue?vue&type=template&id=0d560cee", function () {
      api.rerender('0d560cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/CombinedResultSubjectReportWidget.vue"
export default component.exports